module.exports = {"top3":["Nursing home residents with a hospital admission","Children who are overweight or obese","Home health patients with a hospital admission"],"bottom3":["Uninsured children","Adults with any mental illness who did not receive treatment","Employee insurance costs as a share of median income"],"most_improved":["Adults with any mental illness reporting unmet need","Home health patients without improved mobility","Uninsured children"],"most_declined":["Adults who are obese","Hospital 30-day mortality","Preventable hospitalizations ages 18-64"]}


//////////////////
// WEBPACK FOOTER
// ./src/data/highlights/AZ.json
// module id = 243
// module chunks = 143196823979170 184088790168614